<template>
  <template v-for="item in source" :key="item">
    <a-tag @close="close(item)" color="blue">
      <template #icon>
        <a-space :gutter="5" style="margin-right: 10px;">
          <a-popconfirm title="确定删除吗？" @confirm="() => close(item)">
            <huasky-icon icon="CloseOutlined" />
          </a-popconfirm>
          <huasky-icon icon="EditOutlined" @click="() => edit(item)" />
        </a-space>
      </template>
      {{ item.name }}
    </a-tag>
  </template>
  <a-input v-if="inputVisible" ref="$inputRef" v-model:value.trim="inputValue" type="text" size="small"
    :style="{ width: '78px' }" @blur="onBlur" @keyup.enter="confirm" />
  <a-tag v-else class="add" @click="showInput">
    <huasky-icon icon="PlusOutlined" />
    新增
  </a-tag>
</template>
<script setup lang="ts">
import { removeDataDic, saveDicName } from '@src/scripts/api/setting'
import { saveAppData } from '@src/scripts/system'
import { DataDicGroup } from '@src/scripts/type'
import { onMounted, ref, nextTick } from 'vue'

const props = defineProps<{
  group: DataDicGroup
}>()

const inputVisible = ref(false)
const inputValue = ref('')
const $inputRef = ref()

let editDic: DataDic | undefined       // 记录编辑时的标签id

const source = ref<DataDic[]>([])

const showInput = () => {
  inputVisible.value = true
  editDic = undefined
  nextTick(() => $inputRef.value.focus())
}

const edit = (item: DataDic) => {
  inputVisible.value = true
  inputValue.value = item.name
  editDic = item
  nextTick(() => $inputRef.value.focus())
}

const onBlur = () => {
  inputVisible.value = false
  inputValue.value = ''
}

const confirm = async () => {
  if (!inputValue.value) return
  let body: DataDic | undefined
  if (editDic) {
    body = $util.clone(editDic)
    body.name = inputValue.value
  } else {
    let sort = source.value?.max(a => a.sort) ?? 0
    sort++
    body = { group: props.group, name: inputValue.value, sort }
  }
  const { data } = await saveDicName(body)
  if (editDic) {
    editDic.name = data.name
  } else {
    source.value.push(data)
  }
  saveAppData()
  onBlur()
}

const close = async (item: DataDic) => {
  await removeDataDic(item.id)
  source.value.remove(item)
  saveAppData()
}

onMounted(() => {
  // if (props.group === DataDicGroup.Stall) source.value = $app.dic.stall
  source.value = $app.dic.allDic.filter(a => a.group === props.group)
})

</script>
<style scoped lang="scss">
.add {
  background: #fff;
  border-style: dashed;
  cursor: pointer;
}

:deep(.anticon) {
  opacity: .8;
  cursor: pointer;
}
</style>